import * as React from "react";
import Dropzone from "react-dropzone";

import "./index.scss";

type Props = {
  title: string;
  value: string | File;
  error?: boolean;
  inputId: string;
  inputType?: string;
  isEdit: boolean;
  isFacilitator: boolean;
  onChange(value: string): void;
  onBlur?(value: string): void;
};

const Question: React.FunctionComponent<Props> = ({
  title,
  value,
  error,
  inputId,
  inputType,
  isEdit,
  isFacilitator,
  onChange,
  onBlur,
}: Props): JSX.Element => {
  
  return (
    <div className="question">
      <div className="question__title app-text">{title}</div>

      {inputType === "file" ? (
        <Dropzone
          accept=".png, .svg, .jpg, .jpeg, .gif, .pdf"
          onDrop={(acceptedFiles) => {
            onChange(acceptedFiles[0]);
          }}
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <>
              {(value instanceof File || value instanceof Blob || !value) && (
                <div
                  {...getRootProps()}
                  className={`dropzone-button ${isDragActive ? "active" : ""}`}
                >
                  <input {...getInputProps()} />
                  <i className="far fa-upload fa-lg me-2" />
                  Upload a File
                </div>
              )}

              {value && (
                <div className="dropzone-file mt-1">
                  {value instanceof File || value instanceof Blob ? (
                    <>
                      <strong>File to Upload:</strong> {value.name}
                      <button
                        type="button"
                        className="dropzone-clear"
                        onClick={() => onChange("")}
                        title="Remove file"
                      >
                        <i className="fas fa-times" />
                      </button>
                    </>
                  ) : (
                    <>
                      <strong>File Uploaded:</strong> {value}
                    </>
                  )}
                </div>
              )}
            </>
          )}
        </Dropzone>
      ) : (
        <textarea
          className={`form-control question__input ${
            error ? "is-invalid" : ""
          }`}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={(event) => onBlur?.(event.target.value)}
          id={inputId}
          disabled={!isEdit || isFacilitator}
        />
      )}

      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default Question;
